import React, { useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";

const UniqueGiftsSelection = ({
  uniqueGiftsDropdown,
  setUniqueGiftDropdown,
  handleMenuClose,
  selectedCountry,
}) => {
  const navigate = useNavigate();
  const handleMenuItemClicked = (url) => {
    handleMenuClose(setUniqueGiftDropdown);
    setUniqueGiftDropdown(false);
    navigate(url);
  };

  const [giftCategories, setGiftCategories] = useState([]);

  useEffect(() => {
    try {
      const jsonData = require(`../data/occasions/${selectedCountry}/uniqueGifts.json`);
      setGiftCategories(jsonData);
    } catch (err) {}
  }, [selectedCountry]);

  return (
    <Menu
      anchorEl={uniqueGiftsDropdown}
      open={Boolean(uniqueGiftsDropdown)}
      onClose={handleMenuClose(setUniqueGiftDropdown)}
    >
      {giftCategories.map((category) => (
        <MenuItem
          key={category.key}
          onClick={() => handleMenuItemClicked(`${category.url}`)}
        >
          {category.printable}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default UniqueGiftsSelection;
